import { useDispatch, useSelector } from "react-redux"
import { changeStatus, onFetchImports, selectImportState } from "../redux/slices/importSlice"
import { ApiStatus } from "../types/api/status"
import { ImportAPI } from "../apis/ImportAPI"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"

export const useImportStore = () => {

    const dispatch = useDispatch()
    const { imports, importSelected, status } = useSelector(selectImportState)

    const getImports = async (data?:any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ImportAPI.get(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false 
            }
            const { detail } = response.data
            dispatch(onFetchImports(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const updateImport = async (id: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ImportAPI.update(id, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const downloadTemplate = async (id:number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ImportAPI.download(id)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    return {
        imports,
        importSelected,
        status,
        getImports,
        updateImport,
        downloadTemplate
    }
}